export default {

  getName: state => {
    return state.name
  },
  getBuilderInfo: state => {
    return state.builder
  },
  getCurrentInfo: state => {
    return state.current
  },
  getRedeSocial: state => {
    return state.redeSocial
  },
};


// WEBPACK FOOTER //
// ./src/store/getters.js